import React, { useRef } from "react";
import { MUITable } from "../../../../../common/components";
import {
  campaignMetricsData,
  campaignMetricsHeaders,
} from "../../campaig-performance-metrics";
import { Box, Button } from "@mui/material";
import Select, { components } from "react-select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import "./revenue-per-campaign.scss";
import html2canvas from "html2canvas";

interface RevenuePerCampaignProps {
  metricsData: any;
  exportChart?: (params: any, data?: any, base64Image?: any) => void; // Optional exportChart function
  enableExport?: boolean;
}
const RevenuePerCampaign: React.FC<RevenuePerCampaignProps> = ({
  metricsData,
  exportChart,
  enableExport,
}) => {
  const [format, setFormat] = React.useState({ value: "PDF", label: "PDF" });

  const campaignsRevenue = metricsData?.revenuePerCampaign || [];

  const divToCaptureRef = useRef(null);

  const exportDivAsImageBase64 = async () => {
    if (!divToCaptureRef.current) {
      console.error("Div element not found to capture.");
      return;
    }

    try {
      // Use html2canvas to render the div to a canvas
      const canvas = await html2canvas(divToCaptureRef.current, {
        scale: 2, // Increase scale for better quality image
        useCORS: true, // Important if your div has images from other origins
      });
      const imgURI = canvas.toDataURL("image/png");
      const base64Data = imgURI.split(",")[1];
      return base64Data;
    } catch (error) {
      console.error("Error capturing div as image:", error);
      alert("Error capturing div as image. Check console for details.");
    }
  };

  const handleExport = async () => {
    if (!exportChart) return;

    const params = {
      metrics: "revenuePerCampaign",
      format: format?.value?.toLowerCase(),
    };

    // const base64Image = await exportDivAsImageBase64();
    exportChart(params);
  };

  return (
    <Box className="revenue-contain tenant-details-user-wrapper">
      <Box className="cpl-wrapper">
        <Box
          sx={{
            padding: "10px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <p className="header-text">Revenue Per Campaign</p>
          <Box sx={{ display: "flex", gap: 1 }}>
            <Select
              options={[
                { value: "PDF", label: "PDF" },
                { value: "CSV", label: "CSV" },
              ]}
              isSearchable={false}
              value={format}
              onChange={(selectedOption: any) => setFormat(selectedOption)}
              className="select-dropdown"
              components={{
                IndicatorSeparator: () => null, // ⛔️ removes vertical line
                DropdownIndicator: (props) => {
                  return (
                    <components.DropdownIndicator {...props}>
                      <ArrowDropDownIcon
                        style={{ fontSize: 20, color: "black" }}
                      />
                    </components.DropdownIndicator>
                  );
                },
              }}
            />
            <Button
              variant="outlined"
              onClick={handleExport}
              className="address-edit-button"
              disabled={!enableExport}
            >
              Export
            </Button>
          </Box>
        </Box>
      </Box>
      <div
        ref={divToCaptureRef}
        style={{
          position: "absolute",
          left: "-9999px",
          top: "-9999px",
          width: "800px",
          height: "400px",
          overflow: "hidden",
        }}
      >
        <MUITable
          headers={campaignMetricsHeaders}
          data={campaignsRevenue}
          isStriped={false}
          noResultsTxt="No data available"
        />
      </div>
      <Box className="revenue-table-wrapper">
        <MUITable
          headers={campaignMetricsHeaders}
          data={campaignsRevenue.slice(0, 5)}
          isStriped={false}
          noResultsTxt="No data available"
        />
      </Box>
    </Box>
  );
};

export default RevenuePerCampaign;
